
import Vue from "vue";
import { InboxUpload } from "@/utils/inbox/inbox-upload-job";
import { TranslateResult } from "vue-i18n";

export default Vue.extend({
	data(){
		return {
			uploadJob: InboxUpload
		};
	},
	computed: {
		title():TranslateResult{
			if (this.uploadJob.isSending) return this.$ct("uploading-percent", {percent: this.uploadJob.uploadPercent});
			return this.$ct("analyzing-documents");
		}
	},
	i18nEx: {
		componentPrefix: "components.winbox"
	}
});
